// Site configuration
export const CONFIG = {
  // Contact
  CONTACT_EMAIL: 'contact@internationalresearcholympiad.org',

  // Social Media
  SOCIAL: {
    TWITTER: 'https://twitter.com/IntResearchOly',
    INSTAGRAM: 'https://www.instagram.com/internationalresearcholympiad/',
    LINKEDIN: 'https://www.linkedin.com/company/international-research-olympiad/',
  },

  // External Links
  LINKS: {
    TEXTBOOK: 'https://amzn.to/4inoYWH',
  },
};

export default CONFIG;
